import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { LayoutService } from '../../../Services/layout/layout.service';
import { PlatformLocation } from '@angular/common';
import { Router, Event as RouterEvent, ActivatedRoute } from '@angular/router';
import { includes, startsWith } from 'lodash';
import { ObservablesService } from '../../../Services/observables/observables';
import { ActionApiService } from '../../../Services/action-api/action-api.service';
import { ConfigService } from 'src/app/Services/config.service';
import { ChatbotService } from 'src/app/Services/chatbot-service/chatbot.service';
import { Subscription } from 'rxjs';
import { StoreService } from 'src/app/Services/store';
import * as bowser from 'bowser';
import { CarrierInformationService } from 'src/app/Services/carrier-information-service/carrier-information-service';
const errorStages = ['kickout', 'error'];

@Component({
	selector: 'interview',
	encapsulation: ViewEncapsulation.None,
	template: `
		<ng-template #blockTemplate>
			<loader Message="loading..."> </loader>
		</ng-template>
		<block-ui [template]="blockTemplate">
			<sidebar-panel></sidebar-panel>
			<header></header>
			<preloader *ngIf="showPreloader"></preloader>
			<div *ngIf="!showPreloader">
				<progress-accordion></progress-accordion>
				<headerprogressbar-panel></headerprogressbar-panel>
				<div class="container">
					<sidebar></sidebar>
					<content id="interviewContent" [showFooter]="true"></content>
				</div>
			</div>
			<button *ngIf="showChatBot" class="chat-bot-button" (click)="chatButtonClick()">
				<img src="../assets/images/icons/bot-chat-button.svg" />Chat
			</button>
			<app-chat-bot-dialog
				*ngIf="showChatBot && showChatDialog"
				[ngClass]="{ show: showChatDialog }"
			></app-chat-bot-dialog>
		</block-ui>
	`,
	styleUrls: ['./interview.component.scss'],
})
export class InterviewComponent implements OnInit {
	showPreloader: boolean;
	ajaxInfo: any;
	showChatBot: boolean = false;
	showDialog$: Subscription;
	showChatDialog: boolean = false;
	chatbotInterval: NodeJS.Timeout;
	isMobile: boolean;

	constructor(
		private LayoutService: LayoutService,
		location: PlatformLocation,
		private router: Router,
		private observablesService: ObservablesService,
		private actionApiService: ActionApiService,
		private configService: ConfigService,
		private chatbotService: ChatbotService,
		private storeService: StoreService,
		private carrierInformationService: CarrierInformationService
	) {
		this.showPreloader = false;
		location.onPopState((event: any) => {});
		this.showDialog$ = this.chatbotService.showDialog$.subscribe((res) => {
			this.showChatDialog = res;
		});
	}
	async ngOnInit() {
		this.isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';
		this.LayoutService.staticLayout.subscribe((data) => {
			if (data) {
				this.showPreloader = data.data.metadata.page.state == 'preloader';
			}
		});
		this.initChatbot();

		this.router.events.subscribe((event) => {
			this.initChatbot();
		});
	}

	initChatbot() {
		const globalAttributes = this.storeService.getGlobalAttributes();
		if (globalAttributes) {
			this.chatbotShowCheck(globalAttributes);
		} else {
			this.chatbotInterval = setInterval(() => {
				const globalAttributes = this.storeService.getGlobalAttributes();
				if (globalAttributes) {
					clearInterval(this.chatbotInterval);
					this.chatbotShowCheck(globalAttributes);
				}
			}, 500);
		}
	}

	chatbotShowCheck(globalAttributes: any) {
		this.showChatBot = !!globalAttributes.chatBotAuth && !this.isMobile;
		// if (this.showChatBot) {
		// 	this.chatbotService.createConversationsPostReq();
		// }
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		const layOutStage = this.LayoutService.staticLayout.getValue().data.metadata.page.stage;
		const fromStage = this.router.routerState.snapshot.url.replace('/', '');
		if (layOutStage && includes(errorStages, layOutStage.toLowerCase())) {
			event.preventDefault();
		} else if (fromStage && includes(errorStages, fromStage.toLowerCase())) {
			event.preventDefault();
		} else {
			this.observablesService.showAjaxLoader.next(true);

			if (layOutStage == 'preloader') {
				this.observablesService.showPreloader.next(false);
			} else {
				let arr = window.location.href.split('/');
				let stage = arr[arr.length - 1];
				this.ajaxInfo = startsWith(`${this.configService.getConfig().ENV}`, 'bolt')
					? { action: 'GoToStage', stage }
					: { action: stage };

				this.actionApiService.ajaxAction(this.ajaxInfo, 'page');
				this.observablesService.ShouldPageLoadEvent = 'none';
			}
		}
	}

	chatButtonClick() {
		this.chatbotService.showDialog();
	}
}
